import langs from './langs';
import deApplication from '../../../bin-ldi/json/lang/app/de/application.json';

Object.assign(langs['de/application'], deApplication);

export default langs;
